import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { selectDiscordAgentBindingBarShow } from "features/metadesk/redux/globalState/globalState.selector";
import { setDiscordAgentBindingBarShow } from "features/metadesk/redux/globalState/globalState.action";
import { Banner } from "@metacrm/metacrm-material-ui/dist/Banner";

export default function DiscordAgentBindingBanner() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const discordAgentBindingBarShow = useSelector(
    selectDiscordAgentBindingBarShow
  );
  const [bannerDialogOpen, setBannerDialogOpen] = useState(false);
  const [dontShowBannerAgain, setDontShowBannerAgain] = useState(false);

  const handleCloseDiscordAgentBindingBar = () => {
    if (dontShowBannerAgain) {
      localStorage.setItem("discord_agent_binding_remind_not_show", true);
    }
    dispatch(setDiscordAgentBindingBarShow(false));
  };

  return (
    <Banner
      show={discordAgentBindingBarShow}
      message={formatMessage({ id: "alertBanner.yellow.discordHandleUnbound" })}
      onClickCloseIcon={() => setBannerDialogOpen(true)}
      showDialog
      dialogOpen={bannerDialogOpen}
      setDialogOpen={setBannerDialogOpen}
      dialogTexts={{
        dialogTitle: formatMessage({ id: "popup.versionNotification.title" }),
        dialogMessage: formatMessage({
          id: "popup.versionNotification.description",
        }),
        dialogBtnConfirmText: formatMessage({ id: "global.btn.confirm" }),
        dialogBtnCancelText: formatMessage({ id: "global.btn.cancel" }),
        dialogReminderText: formatMessage({ id: "global.btn.reminder" }),
      }}
      onClickConfirmCloseBanner={handleCloseDiscordAgentBindingBar}
      dontShowBannerAgain={dontShowBannerAgain}
      setDontShowBannerAgain={setDontShowBannerAgain}
    />
  );
}
